<template>
  <div>
    <el-breadcrumb class="Breadcrumb" separator="/">
      <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
   
      <el-row :gutter="24">
        <el-col :span="4" :offset="20">
          <el-button type="primary" @click="openAdd()" icon="el-icon-plus">添加</el-button>
        </el-col>
      </el-row>
      <div class="table">
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column prop="createdTate" label="创建时间">
          </el-table-column>
          <el-table-column prop="title" label="标题">
          </el-table-column>
          <el-table-column prop="imageAddress" label="封面">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: 100px" :src="scope.row.imageAddress"
                :preview-src-list="scope.row.imgAddressList" fit="contain" v-if="scope.row.imgAddressList"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="启用/禁用">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.isUsed" active-color="#13ce66" inactive-color="#ff4949"
                :disabled="scope.row.canEdit == false" @change="changeDemo(scope.row.id, scope.row.isUsed)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="check" label="查看次数">
          </el-table-column>
          <el-table-column prop="updateDate" label="最后操作时间">
          </el-table-column>
          <el-table-column prop="id" fixed="right" label="操作" width="250">
            <template slot-scope="scope">
              <el-button @click="topFun(scope.row.id)" type="text" icon="el-icon-upload2" size="small">置顶</el-button>
              <el-button @click="upFun(scope.row.id)" type="text" icon="el-icon-caret-top" size="small">上移</el-button>
              <el-button @click="downFun(scope.row.id)" type="text" icon="el-icon-caret-bottom"
                size="small">下移</el-button>
              <el-button @click="bottomFun(scope.row.id)" type="text" icon="el-icon-download" size="small">置底</el-button>
              <el-button @click="editFun(scope.row.id)" type="text" icon="el-icon-edit" size="small">编辑</el-button>
              <el-button @click="deleteFun(scope.row.id)" type="text" icon="el-icon-delete" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination background @size-change="changSizeFun" @current-change="changpageFun"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>

    <!-- 添加弹窗-->
    <el-dialog :title="popTitle" :visible.sync="addPop" @close="resetForm('ruleForm')">
      <el-form :model="formDate" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item label="标题" prop="title" wight="100px">
          <el-input placeholder="请输入新闻标题" v-model="formDate.title"></el-input>
        </el-form-item>
        <el-form-item label="封面" prop="imgAddress">
          <el-upload :action="uploadUrl" :headers="upheader" list-type="picture-card" :auto-upload="true"
            :on-success="iconSuccess" :file-list="formDate.imgAddressList" accept="image/jpg,image/jpeg,image/png"
            :before-upload="iconBeforeUpload">
            <i slot="default" class="el-icon-upload"></i>
            <div slot="formDate" slot-scope="{formDate}">
              <img class="el-upload-list__item-thumbnail" :src="formDate.imgAddress" alt="">
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-delete" @click="iconRemove">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="联系人" prop="linkman">
          <el-input placeholder="请输入联系人" v-model="formDate.linkman"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="mobile">
          <el-input placeholder="请输入联系人电话" v-model="formDate.mobile"></el-input>
        </el-form-item>
        <el-form-item label="发布周期时间" prop="sendDate">
          <el-date-picker @change="changeTime" v-model="formDate.sendDate" class="inner-input" value-format="yyyy-MM-dd"
            type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="发布内容" prop="content">
          <Fuwenben ref="fuwenben" :htmlData="formDate.content" v-model="formDate.content"></Fuwenben>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="addNewsFun('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Fuwenben from '@/components/fuwenben.vue'

export default {
  mounted() {
    this.getTitle();
  },
  components: {
    Fuwenben
  },
  methods: {
    //查询列表
    getTitle() {
      let data = {
        key:this.key
      }
      this.$get(api + "/newsPress/getDdicNameByKey", data).then(response => {
        let res = response.data;
        if (res.code == 0) {
          this.name = res.data ;
          this.getList();
        } else {
          this.$message('获取错误')
        }
      }).catch(err => {
        console.log('err', err)
        this.$message(err)
      })
    },
    // handleClick(tab, event) {
    //   this.key = tab.name;
    //   this.name = tab.label;
    //   this.pageSize = 10,
    //     this.pageNum = 1,
    //     this.totalNum = 0,
    //     this.getList();
    // },
    getList() {
      let data = {
        ddic: this.key,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$get(api + "/newsPress/getList", data).then(response => {
        let res = response.data;
        if (res.code == 0) {
          res.data.forEach(element => {
            if (element.imageAddress) {
              element.imgAddressList = [element.imageAddress]
            }
          });
          this.tableData = res.data;
          this.totalNum = res.totalNum
        }
      })
    },
    //打开添加页面
    openAdd() {
      this.formDate = {};
      this.addPop = true;
      this.popTitle = '添加'+this.name;
      this.uploadUrl = api + '/main/'+this.key+'/upload'
      this.upheader = { "token": this.$store.state.userInfo.token }
      // this.$refs.fuwenben.$data.html = '';
      this.$nextTick(() => {
        this.$refs.fuwenben.clear();
      })
    },
    //添加此类目新闻
    addNewsFun(formName) {
      this.formDate.content = this.$refs.fuwenben.$data.html;
      if(!this.formDate.sendDate){
        this.formDate.sendDate = ["2000-01-01","2099-12-31"]
      }
      let data = {
        title: this.formDate.title,
        imageAddress: this.formDate.imageAddress,
        linkman: this.formDate.linkman,
        mobile: this.formDate.mobile,
        sendStartDate: this.formDate.sendDate[0],
        sendEndDate: this.formDate.sendDate[1],
        content: this.formDate.content,
        ddic: this.key,
        id: this.formDate.id
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.formDate.id) {
            this.$post(api + "/newsPress/addNewsPress", data).then(response => {
              let res = response.data;
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '添加成功!'
                })
                this.formDate = {};
                this.addPop = false;
                this.getListFun(1);
              } else {
                this.$message.error(res.desc);
              }
            })
          } else {
            this.$post(api + "/newsPress/editNewsPress", data).then(response => {
              let res = response.data;
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '编辑成功!'
                })
                this.formDate = {};
                this.addPop = false;
                this.getListFun(1);
              } else {
                this.$message.error(res.desc);
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });


    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.addPop = false;
    },
    //开启/关闭新闻
    changeDemo(id, isUsed) {
      //true = 开启 false = 关闭
      let data = {}
      let uri = isUsed ? "enable" : "disable"
      let url = "/newsPress/" + uri + "/" + id;
      this.$post(api + url, data).then(response => {
        let res = response.data;
        if (res.code == 0) {
          this.getListFun(this.pageNum);
        } else {
          this.$message.error(res.desc);
        }
      })
    },
    topFun(id) {
      let url = "/newsPress/top/" + id;
      this.changePlace(url);
    },
    upFun(id) {
      let url = "/newsPress/up/" + id;
      this.changePlace(url);
    },
    downFun(id) {
      let url = "/newsPress/down/" + id;
      this.changePlace(url);
    },
    bottomFun(id) {
      let url = "/newsPress/bottom/" + id;
      this.changePlace(url);
    },
    //换位置
    changePlace(url) {
      let data = {}
      this.$post(api + url, {}).then(response => {
        let res = response.data;
        if (res.code == 0) {
          this.getListFun(this.pageNum);
        } else {
          this.$message.error(res.desc);
        }
      })
    },
    editFun(id) {
      console.log('ojb', id);
      let data = {}
      this.uploadUrl = api + '/main/'+this.key+'/upload'
      this.upheader = { "token": this.$store.state.userInfo.token }
      this.addPop = true;
      this.$get(api + "/newsPress/getInfo/" + id, data).then(res => {
        this.popTitle = '编辑'+this.name;
        this.formDate = res.data.data;
        this.formDate.id = id;
        this.formDate.imageAddress = this.formDate.imageAddress;
        this.formDate.imgAddressList = [{
          uid: this.formDate.imageAddress,
          url: this.formDate.imageAddress
        }];
        this.formDate.sendDate = [this.formDate.sendStartDate, this.formDate.sendEndDate]
        this.$refs.fuwenben.$data.html = this.formDate.content;
        console.log('this.formDate', this.formDate);
      })
    },
    deleteFun(id) {
      let data = {}
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post(api + "/newsPress/delete/" + id, data).then(response => {
          let res = response.data;
          if (res.code == 0) {
            this.getListFun(1);
          } else {
            this.$message.error(res.desc);
          }
        })
      }).catch(() => {

      });

    },
    changeTime(value) {
      this.formDate.sendDate = value
      console.log("======>",this.formDate)
    },
    //特定pageNum查询列表
    getListFun(val) {
      this.pageNum = val;
      this.getList();
    },

    //更换pageSize
    changSizeFun(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    //翻页
    changpageFun(val) {
      console.log(this.pageNum);
      this.pageNum = val;
      this.getList();
    },

    iconBeforeUpload(file) {
      var img = file.name.substring(file.name.lastIndexOf('.') + 1)
      const suffix = img === 'jpg'
      const suffix2 = img === 'png'
      const suffix3 = img === 'jpeg'
      // const isLt1M = file.size / 1024 / 1024 < 1;
      if (!suffix && !suffix2 && !suffix3) {
        this.$message.error("只能上传图片！");
        return false
      }
      // 可以限制图片的大小
      // if (!isLt1M) {
      //     this.$message.error('上传图片大小不能超过 1MB!');
      // }
      return suffix || suffix2 || suffix3
    },
    iconSuccess(response, file, fileList) {
      this.formDate.imageAddress = response.data.fullUrl;
      this.formDate.imgAddressList = [file];
    },
    iconRemove() {
      this.formDate.imageAddress = '';
      this.formDate.imgAddressList = [];
    },

  },
  data() {
    return {
      key: this.$route.query.key,
      name: '',
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      titleData: [],
      tableData: [],
      addPop: false,
      popTitle: '',
      formDate: {
        title: '',
        content: '',
        sendDate:[],
      },
      rules: {
        title: [
          { required: true, message: '请输入新闻名称', trigger: 'blur' },
          { min: 1, message: '请至少输入1个字', trigger: 'blur' }
        ]
      }
    }
  }
}
</script>


<style scoped>
.upload-demo {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.Breadcrumb {
  margin-bottom: 15px;
}

.search {
  padding-bottom: 10px;
  border-bottom: 1px solid #606266;
  margin-bottom: 15px;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.inner-input{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/innovation/SendItem.vue